import { usePlotOverrides } from '../contexts/plotController/plotControllerContext';
export function usePlotControllerAxes(options = {}) {
    const { axes } = usePlotOverrides(options);
    return axes;
}
//# sourceMappingURL=usePlotControllerAxes.js.map